import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });


  const BillTo = ({user}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Facture pour :</Text>
        <Text>{user.name}</Text>
        <Text>{user.phoneNumber}</Text>
        <Text>{user.email}</Text>
    </View>
  );
  
  export default BillTo